import { Directive, Output, EventEmitter, ElementRef, OnDestroy, Input } from '@angular/core';
import { fromEvent, Subscription, merge, Observable } from 'rxjs';

@Directive({
  selector: '[tdWbImageLoad]'

})
export class ImageLoadDirective implements OnDestroy {
  @Input('tdWbImageLoad') needListener: boolean;
  @Output() readonly imageLoad: EventEmitter<void> = new EventEmitter<void>();

  private changes: MutationObserver;
  private subscription: Subscription;

  constructor(private elementRef: ElementRef) {
    const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: Array<MutationRecord>): void => {
      if (this.needListener) {
        mutations.forEach((mutation: MutationRecord): void => {
          switch (mutation.type) {
            case 'childList':
              Array.from((mutation.target as HTMLElement).children).forEach((child: Element): void => {
                const images = Array.from(child.getElementsByTagName('img'));
                const imageLoadEvents = images.map((img: HTMLImageElement): Observable<Event> => fromEvent(img, 'load'));
                if (this.subscription !== undefined) {
                  this.subscription.unsubscribe();
                }
                this.subscription = merge(...imageLoadEvents)
                  .subscribe((): void => {
                    this.imageLoad.emit();
                  });
              });
          }
        });
      }
    });

    this.changes.observe(element, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }
}
